import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const contentTypeEducation: Step = {
    id: OnboardingFlows.UseCases,
    title: 'How do you plan to use D-ID?',
    showCondition: {
        stepId: OnboardingFlows.NewDepartment,
        selectedOption: 'Academy, K-12, Teacher, Student',
    },
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'How-to guide',
        },
        {
            label: 'Classroom engagement',
        },
        {
            label: 'Parent communications',
        },
        {
            label: 'Student projects',
        },
        {
            label: 'Lecture materials',
        },
        {
            label: 'Online learning',
        },
        {
            label: 'Presentations',
        },
        {
            label: 'Interactive conversational Avatars',
        },
        {
            label: 'Other',
        },
    ],
};
